import React, { useContext, useEffect, useState } from 'react'
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import { useDispatch, useSelector } from 'react-redux';

import authContext from '../../context/authContext/authContext';
import Loader from '../../utils/Loader';
import { getProductsAction, selectProductAction } from '../../redux/actions/productsAction';

const initialState = { loading: false, clientId: '', productId: '' }

const ClaimerModal = ({ isOpen, toggle }) => {
  const dispatch = useDispatch();

  const { user, getConfig } = useContext(authContext);
  const config = getConfig();
  const { user: currentUser } = useSelector((state) => state.user);

  const getProducts = () => {
    dispatch(getProductsAction(config));
  };


  const { products: propsProducts, loading } = useSelector((state) => state.products);

  const [state, setCompleteState] = useState({ ...initialState, clientId: currentUser?.clientId })
  const setState = (newState) => setCompleteState((prevState) => ({ ...prevState, ...newState }));

  useEffect(() => {
    if (user && isOpen) {
      getProducts();
    }
  }, [isOpen])

  const products = propsProducts?.reduce((acc, item) => {
    return acc.concat(item.subProducts || []);
  }, []);

  const onHideModal = () => {
    setState(initialState)
    toggle();
  }

  const selectProduct = (productId, clientId) => {
    const data = { productId, clientId }
    dispatch(selectProductAction(config, data, getProducts, onHideModal))
  }

  const handleSubmit = () => {
    selectProduct(state.productId, state.clientId);
    onHideModal()
  }

  return (
    <Modal isOpen={isOpen} toggle={onHideModal} size='lg'>
      <ModalHeader toggle={onHideModal}>
        <div className='d-flex align-items-center'>
          <div className='fw-600'>Claim Tokens</div>
          <div className='ml-3'>
            <Loader isLoading={loading} />
          </div>
        </div>
      </ModalHeader>
      <ModalBody>
        <div className='row'>
          <div className='col-md-6 mb-4'>
            <div class="form-group">
              <ladbel class="">Choose product</ladbel>
              <div class="input-group mt-2">
                <select class="custom-product-select" onChange={(e) => setState({ productId: e.target.value })}>
                  <option selected value={""}>Choose...</option>
                  {products?.map((product) => {
                    return (
                      <option value={product._id}>{product.title}</option>
                    )
                  })}
                </select>
              </div>
            </div>
          </div>

          <div className='col-md-6 mb-4'>
            <div class="form-group">
              <label>Client ID</label>
              <input
                type="email"
                class="form-control"
                value={currentUser?.clientId || state?.clientId}
                onChange={(e) => setState({ clientId: e.target.value })}
                disabled={currentUser?.clientId}
              />
              <small class="form-text text-muted">We'll verify your account by client ID</small>
            </div>
          </div>
        </div>
      </ModalBody>
      <ModalFooter>
        <Button color="secondary" onClick={onHideModal} disabled={loading}>
          Cancel
        </Button>
        <Button color="gleamdesk" onClick={handleSubmit} disabled={loading || !state.productId || !state.clientId}>
          Claim
        </Button>
      </ModalFooter>
    </Modal>
  )
}

export default ClaimerModal
